import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
`

export const Input = styled.input`
  letter-spacing: 0.01em;
  display: block;
  height: 40px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: 8px;
  padding: 0 12px;
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.textPrimary};
  background: ${({ theme }) => theme.colors.background};
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: ${({ theme }) => theme.colors.textMuted};
  }

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.borderStrong};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.action.primary.bg};
    box-shadow: 0 0 0 3px rgba(62, 207, 142, 0.18);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    background: ${({ theme }) =>
      theme.name === 'dark' ? theme.colors.backgroundSecondary : theme.colors.borderSubtle};
    color: ${({ theme }) => theme.colors.textMuted};
  }
`

export const ElLabel = styled.label`
  display: block;
  margin-bottom: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textSecondary};
`
